export const MetricUnits = Object.freeze({
  Metre: "Metre",
  Millimetre: "Millimetre",
  MillimetreSquared: "MillimetreSquared",
  KiloNewton: "KiloNewton",
  KiloNewtonDividedByMetreSquared: "KiloNewtonDividedByMetreSquared",
  Megapascal: "Megapascal",
});

export const ImperialUnits = Object.freeze({
  Foot: "Foot",
  Inch: "Inch",
  InchSquared: "InchSquared",
  Kilopound: "Kilopound",
  KilopoundPerSquaredFoot: "KilopoundPerSquaredFoot",
  KilopoundPerSquareInch: "KilopoundPerSquareInch",
  PoundPerSquaredInch: "PoundPerSquaredInch",
});

export function IsMetricUnit(val) {
  return Object.values(MetricUnits).includes(val);
}

export function IsImperialUnit(val) {
  return Object.values(ImperialUnits).includes(val);
}
